import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { OtpResponse, OtpData } from 'src/interfaces/otp.interface';
import { map, catchError, switchMap } from 'rxjs/operators';
import { UserService } from './user.service';

interface UserAttribute {
  Name: string;
  Value: string;
}

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  private apiUrl = `${environment.api.baseUrl}/otp`;

  constructor(private http: HttpClient, private userService: UserService) {}

  /**
   * Get OTP details by order number, and fetch user first/last name
   * @param order_number The order number to look up
   * @returns Observable<{ otp: OtpData | null, user: { Attributes: UserAttribute[], user_id: string } | null }>
   */
  getOtpByOrder(order_number: string): Observable<{ otp: OtpData | null, user: { Attributes: UserAttribute[], user_id: string } | null }> {
    return this.http.post<OtpResponse>(`${this.apiUrl}/by-order`, { order_number }).pipe(
      map(response => response.data),
      switchMap((otp: OtpData | null) => {
        if (otp && otp.user_id) {
          return from(this.userService.getUser(otp.user_id)).pipe(
            map(user => ({
              otp,
              user: user ? { Attributes: user.Attributes, user_id: otp.user_id } : null
            })),
            catchError(() => of({ otp, user: null }))
          );
        } else {
          return of({ otp, user: null });
        }
      }),
      catchError(() => of({ otp: null, user: null }))
    );
  }
} 